class SliderPress extends HTMLElement {
  constructor() {
    super();

    this.mainSliderElement = this.querySelector("[data-slider-main]");
    this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");
    this.thumbsSlidesCount = Number(
      this.thumbsSliderElement?.dataset?.slidesCount || 0
    );

    if (this.mainSliderElement && this.thumbsSliderElement) {
      this.mainSlider = new Splide(this.mainSliderElement, {
        pagination: false,
        waitForTransition: false,
        arrows: false,
      });
      this.thumbsSlider = new Splide(this.thumbsSliderElement, {
        pagination: false,
        waitForTransition: false,
        arrows: false,
        drag: true,
        isNavigation: true,
        perPage: this.thumbsSlidesCount,
        gap: "1rem",
        autoWdith: true,
        breakpoints: {
          1200: {
            gap: 0,
            perPage: this.thumbsSlidesCount >= 2 ? 2 : this.thumbsSlidesCount,
          },
          990: {
            perPage: 1,
            autoWidth: false,
          },
        },
      }).mount();

      this.mainSlider.sync(this.thumbsSlider).mount();
    } else {
      this.initMarquee();
    }
  }

  /* Auto-scrolling logo strip for "Brands we offer" (logos without captions). */
  initMarquee() {
    const row = this.querySelector(".press__logos:not([data-slider-thumbs])");
    if (!row || row.dataset.marquee) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    row.dataset.marquee = "true";

    if (!document.getElementById("press-marquee-style")) {
      const style = document.createElement("style");
      style.id = "press-marquee-style";
      style.textContent = `
        .press__logos.press__logos--marquee { display: block; overflow: hidden; margin: 0; -webkit-mask-image: linear-gradient(to right, transparent, #000 8%, #000 92%, transparent); mask-image: linear-gradient(to right, transparent, #000 8%, #000 92%, transparent); }
        .press__marquee-track { display: flex; width: max-content; animation: press-marquee var(--press-marquee-duration, 30s) linear infinite; }
        .press__logos--marquee:hover .press__marquee-track,
        .press__logos--marquee:focus-within .press__marquee-track { animation-play-state: paused; }
        .press__marquee-group { display: flex; align-items: center; flex-shrink: 0; }
        .press__logos--marquee .press__logo { flex: 0 0 auto !important; min-width: 0 !important; margin: 0 !important; padding: 0 3.2rem; }
        .press__logos--marquee .press__logo img { width: auto !important; height: 6rem; max-width: none !important; object-fit: contain; }
        @media screen and (max-width: 749px) {
          .press__logos--marquee .press__logo { padding: 0 2rem; }
          .press__logos--marquee .press__logo img { height: 4.4rem; }
        }
        @keyframes press-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
      `;
      document.head.appendChild(style);
    }

    const logos = Array.from(row.children);
    if (!logos.length) return;

    const group = document.createElement("div");
    group.className = "press__marquee-group";
    logos.forEach((logo) => group.appendChild(logo));

    // Repeat the logos so one group is wider than the screen.
    for (let i = 0; i < 3; i++) {
      logos.forEach((logo) => {
        const copy = logo.cloneNode(true);
        copy.setAttribute("aria-hidden", "true");
        copy.querySelectorAll("a").forEach((a) => a.setAttribute("tabindex", "-1"));
        group.appendChild(copy);
      });
    }

    // A second identical group makes the loop seamless.
    const groupCopy = group.cloneNode(true);
    groupCopy.setAttribute("aria-hidden", "true");
    groupCopy.querySelectorAll("a").forEach((a) => a.setAttribute("tabindex", "-1"));

    const track = document.createElement("div");
    track.className = "press__marquee-track";
    track.style.setProperty("--press-marquee-duration", `${Math.max(20, logos.length * 8)}s`);
    track.append(group, groupCopy);

    row.appendChild(track);
    row.classList.add("press__logos--marquee");
  }
}

customElements.define("slider-press", SliderPress);
